<p-dialog [header]="displayType === 'files' ? 'Files' : 'Pictures'" 
          [(visible)]="displayDialog" 
          [modal]="true" 
          [style]="{width: '60vw'}" 
          (onHide)="hideFileViewModal()">
    <div class="card">
        <p-table [value]="displayItems" 
                [paginator]="true" 
                [rows]="10" 
                [showCurrentPageReport]="true"
                [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} ' + (displayType === 'files' ? 'files' : 'pictures')"
                [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th style="width: 150px">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <span class="truncate" [pTooltip]="item?.fileName" tooltipPosition="top">
                            {{item.fileName | shorten:30}}
                        </span>
                    </td>
                    <td>
                        <div class="p-d-flex gap-2">
                            <button pButton type="button" 
                                    icon="pi pi-eye" 
                                    class="p-button-rounded p-button-text"
                                    (click)="previewListingFile($event, item, false)"
                                    [pTooltip]="'View ' + (displayType === 'files' ? 'File' : 'Picture')" 
                                    tooltipPosition="top">
                            </button>
                            <button pButton type="button" 
                                    icon="pi pi-download" 
                                    class="p-button-rounded p-button-text"
                                    (click)="previewListingFile($event, item, true)"
                                    [pTooltip]="'Download ' + (displayType === 'files' ? 'File' : 'Picture')" 
                                    tooltipPosition="top">
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="hideFileViewModal()" label="Close" class="p-button-secondary"></button>
    </p-footer>
</p-dialog> 